<template>
  <div class="main">
    <div v-if="btnInfo.price" class="mainbox">
      <div
        class="price"
        @click=" cancelOrder">
        <p class="price-num">
          <span v-if="btnInfo.isWait" class="paywait">待支付&nbsp;</span>
          <span class="unit">¥&nbsp;</span>
          <span class="unit-price">{{ btnInfo.price }}</span>
          <span class="time">&nbsp;{{ btnInfo.isTimeOrNum }}</span>
        </p>
        <!-- <p v-show="btnInfo.text" class="text">{{ btnInfo.text }}</p> -->
      </div>
      <div class="btn">
        <p
          :class="{gray:btnInfo.isGray}"
          class=""
          @click="btnClick">{{ btnInfo.btnText }}</p>
      </div>
    </div>
    <div v-if="!btnInfo.price" class="mainbox mainbox2" @click="btnClick">{{ btnInfo.btnText }}</div>
  </div>
</template>

<script>
export default {
  name: 'FixBtn',
  props: {
    btnInfo: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  methods: {
    btnClick () {
      this.$emit('btnClick')
    },
    cancelOrder () {
      this.$emit('cancelOrder')
    }
  }
}
</script>

<style lang="scss" scoped>
  .main {
    height: 60px;
    background: #fff;
    position: fixed;
    background: #fff;
    font-size: 16px;
    z-index: 1;
    color: #fff;
    text-align: center;
    width: 100%;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    // padding: 0 $padding;
    box-sizing: border-box;
  }
  .main {
    background: #fff;
    font-size: 16px;
    z-index: 1;
    color: #fff;
    text-align: center;
    width: 100%;
    bottom: 0;
    left: 0;
    // display: flex;
    // align-items: center;
    padding: 0 $padding;
    border-top: 1px solid #E5E5E5;
    box-sizing: border-box;
    .mainbox{
      margin-top: 7px;
      width: 100%;
      height: 45px;
      line-height: 45px;
      box-sizing: border-box;
      border-radius: 22px;
      background: url(https://cdn.51ljb.cn/ljb_icons_service_fixed_ljzx.png) no-repeat;
      background-size: 100% 100%;
    }
    .mainbox2{
      background: linear-gradient(90deg, #EBD2A8 0%, #E9BA66 100%);
      text-align: center;
      color: #402200;
      font-weight: 500;
    }
    .price{
      // text-align: left;
      // width: calc(100% - 102px);
      // background: #fff;
      box-sizing: border-box;
      height: 100%;
      float: left;
      // display: flex;
      // justify-content: center;
      // flex-direction: column;
      .price-num{
        height: 100%;
        color: #FADD95;
        font-weight: 500;
        margin-left: 25px;
        .paywait{
          font-size: 12px;
          color: #fff;
        }
        .unit{
          font-size: 12px;
        }
        .unit-price{
          font-size: 18px;
        }
        .time{
          font-size: 15px;
          color: #fff;
        }
      }
      .text{
        margin-top: 6px;
        font-size: 11px;
        line-height: 11px;
        color: $text-color;
      }
    }
    &:after{
      content: " ";
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 1px;
      background-color: $border-color;
      -ms-transform-origin: 0 0;
      transform-origin: 0 0;
      transform: scaleY(0.5);
    }
  }
  .commit-text{
    /*width: 162px;*/
    // flex: 1;
    border-radius: 1px;
    background: $base-color;
    line-height: 40px;
    &.gray{
      background: #ccc;
    }
  }

  .btn{
    // flex: 1;
    width: 102px;
    text-align: center;
    font-size: 15px;
    font-weight: 500;
    color: #402200;
    float: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/FixBtn.vue